import { ApplicationRef, ComponentRef, Injectable, Injector, createComponent } from '@angular/core'
import { UnsavedModalComponent } from '@components'

@Injectable({ providedIn: 'root' })
export class UnsavedModalService {
  private modalRef?: ComponentRef<UnsavedModalComponent>

  constructor(
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  askUser(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.modalRef = createComponent(UnsavedModalComponent, {
        environmentInjector: this.appRef.injector,
        elementInjector: this.injector,
      })

      this.modalRef.instance.confirm.subscribe(() => {
        resolve(true)
        this.close()
      })

      this.modalRef.instance.cancel.subscribe(() => {
        resolve(false)
        this.close()
      })

      this.appRef.attachView(this.modalRef.hostView)
      document.body.appendChild(this.modalRef.location.nativeElement)
    })
  }

  private close() {
    if (!this.modalRef) return
    this.appRef.detachView(this.modalRef.hostView)
    this.modalRef.destroy()
    this.modalRef = undefined
  }
}
